import React, { FC, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components/macro'
import { Svg } from './Icon'
import { swaapRed0, swaapPurple1 } from '../../Themes'

interface CrossProps {
  onClick: () => void
  className?: string
}

interface BoldCrossProps {
  color?: string
}

export const Cross = ({ className, onClick }: CrossProps) => (
  <Span className={className}>
    <Svg viewBox="0 0 24 18" onClick={onClick} strokeWidth={2} fill="none">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </Svg>
  </Span>
)

const Span = styled.span`
  opacity: 0.5;
  padding: 5px;
  &:hover {
    opacity: 1;
    cursor: pointer;
  }
`

export function SmallRedCross() {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 20 20"
        color={swaapRed0}
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="feather feather-x"
      >
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </div>
  )
}

export const BoldCross: FC<BoldCrossProps> = ({ color }: BoldCrossProps) => {
  // @ts-ignore
  const theme = useContext(ThemeContext)

  if (color != undefined) {
    return (
      <div>
        <Svg viewBox="0 0 24 18" strokeWidth={4} fill="none" color={color}>
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </Svg>
      </div>
    )
  }

  return (
    <div>
      <Svg
        viewBox="0 0 24 18"
        strokeWidth={4}
        fill="none"
        color={theme.appStatusColorOutdated}
      >
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </Svg>
    </div>
  )
}

interface PanelCrossProps {
  onClick?: () => void
  className?: string
  color: string
  width: number
}
export const PanelCross: FC<PanelCrossProps> = ({
  color,
  className,
  onClick,
  width,
}) => {
  return (
    <PanelSvg
      viewBox="0 0 24 24"
      onClick={onClick}
      strokeWidth={4}
      fill="none"
      color={color}
      className={className}
      width={width}
      height={width}
    >
      <line x1="24" y1="0" x2="0" y2="24" stroke="white" strokeWidth="4" />
      <line x1="0" y1="0" x2="24" y2="24" stroke="white" strokeWidth="4" />
    </PanelSvg>
  )
}

const PanelSvg = styled.svg<{ color: string }>`
  line {
    stroke: ${props => props.color};
  }
  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }
`
